import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "../";
import { ListController } from "./listController";

listConfig.$inject = ["formlyConfigProvider", WorkItemServiceProviderName];
export function listConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider,
) {
  workItemServiceProvider.addWorkItemType({
    name: "List",
    formlyFieldType: "processList",
  });

  formlyConfigProvider.setType({
    name: "processList",
    template: require("!html-loader!./index.html").default,
    controller: ListController,
  });
}
